import { render } from "./TheImageModal.vue?vue&type=template&id=a9707f50"
import script from "./TheImageModal.vue?vue&type=script&lang=js"
export * from "./TheImageModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__